import { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Users, Clock, BarChart3, LogOut, X, Fingerprint, AlertCircle, Building2, FileBarChart } from "lucide-react"; // añadimos AlertCircle para incidencias

const menuItems = [
  { path: "/admin/dashboard", label: "Dashboard", icon: <BarChart3 size={20} /> },
  { path: "/admin/empresa", label: "Empresa", icon: <Building2 size={20} /> },
  { path: "/admin/empleados", label: "Empleados", icon: <Users size={20} /> },
  { path: "/admin/fichajes", label: "Fichajes", icon: <Clock size={20} /> },
  { path: "/admin/fichar", label: "Fichar", icon: <Fingerprint size={20} /> },
  { path: "/admin/incidencias", label: "Incidencias", icon: <AlertCircle size={20} /> },
  { path: "/admin/informes", label: "Informes", icon: <FileBarChart size={20} /> }, // 👈 NUEVO

];


export default function Sidebar({ className = "", onClose }) {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <aside
      className={`d-flex flex-column vh-100 shadow ${className}`}
      style={{ width: "250px", backgroundColor: "#2d3d4a" }}
    >
      {/* Header */}
      <div
        className="d-flex align-items-center justify-content-between px-3 py-2"
        style={{ height: "64px", backgroundColor: "#fe7f25" }}
      >
        <NavLink to="/" className="d-flex align-items-center text-white text-decoration-none">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="currentColor"
            className="me-2"
            viewBox="0 0 16 16"
          >
            <path d="M8.515 1.019A7 7 0 1 0 15 8a.5.5 0 0 0-1 0 6 6 0 1 1-5.485-6.981z" />
            <path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l3.15 1.85a.5.5 0 1 1-.5.866L7.5 8.5V3.5A.5.5 0 0 1 7.5 3z" />
          </svg>
          <span className="fw-bold">Turnora</span>
        </NavLink>

        {onClose && (
          <button className="btn d-md-none text-white" onClick={onClose}>
            <X size={24} />
          </button>
        )}
      </div>

      {/* Menu */}
      <nav className="flex-grow-1 overflow-auto">
        <ul className="nav flex-column px-2 py-3">
          {menuItems.map((item) => (
            <li className="nav-item mb-2" key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `nav-link d-flex align-items-center rounded text-decoration-none ${
                    isActive ? "active text-white" : "text-white"
                  }`
                }
                style={({ isActive }) => ({
                  backgroundColor: isActive ? "#fe7f25" : "transparent",
                  padding: "0.5rem 1rem",
                  transition: "background-color 0.2s",
                })}
              >
                {item.icon}
                <span className="ms-3">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="px-3 py-3 border-top" style={{ borderTopColor: "#fe7f25" }}>
        <button
          className="btn w-100 d-flex align-items-center justify-content-start mb-2"
          style={{
            backgroundColor: "#fe7f25",
            color: "#fff",
            border: "none",
          }}
          onClick={() => navigate("/admin/subscribe")}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#fe9728")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fe7f25")}
        >
          <BarChart3 size={20} />
          <span className="ms-3">Suscripción</span>
        </button>
        
        <button
          className="btn w-100 d-flex align-items-center justify-content-start"
          style={{
            backgroundColor: "#fff",
            color: "#2d3d4a",
            border: "1px solid #2d3d4a",
          }}
          onClick={handleLogout}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#fe7f25";
            e.currentTarget.style.color = "#fff";
            e.currentTarget.style.borderColor = "#fe7f25";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#fff";
            e.currentTarget.style.color = "#2d3d4a";
            e.currentTarget.style.borderColor = "#2d3d4a";
          }}
        >
          <LogOut size={20} />
          <span className="ms-3">Cerrar sesión</span>
        </button>
        <span style={{color: "white",fontSize: "11px"}}>Versión 0.1</span>
      </div>
    </aside>
  );
}
